import { Component, HostBinding, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings, Settings } from 'src/app/app.settings';
import { HostService } from 'src/app/services/host.service';

@Component({
  selector: 'app-entreprise',
  templateUrl: './entreprise.component.html',
  styleUrls: ['./entreprise.component.scss']
})
export class EntrepriseComponent implements OnInit {
  public settings: Settings;
  @HostBinding('style.--urlImage') nameOfVar = `url('${this.getHost.getHttpsImage()}imageEntreprise/image.jpg')`;
  constructor(
    public appSettings:AppSettings, 
    public router:Router,
    public getHost:HostService,
  ) {}

  ngOnInit() {
  }

  ngAfterViewInit(){
    document.getElementById('preloader')?.classList.add('hide');
  }


}
